import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, normalizeClass as _normalizeClass, renderSlot as _renderSlot, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2dd62e8c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "panel-collapse control-panel relative" }
const _hoisted_2 = {
  key: 0,
  class: "label-panel label_t-r"
}
const _hoisted_3 = { class: "label-text" }
const _hoisted_4 = {
  key: 1,
  class: "label-panel label_t-l"
}
const _hoisted_5 = { class: "label-text" }
const _hoisted_6 = { class: "panel-header flex flex-column xl:flex-row justify-content-between xl:align-items-center" }
const _hoisted_7 = { class: "flex flex-column w-full align-items-start" }
const _hoisted_8 = {
  key: 0,
  class: "title mb-s1 flex align-items-center"
}
const _hoisted_9 = { class: "flex flex-wrap flex-grow-1" }
const _hoisted_10 = {
  class: "toggleable-content",
  role: "region"
}
const _hoisted_11 = { class: "panel-content" }

import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRouter } from 'vue-router';
import { useI18n } from 'vue-i18n';
import { buildSwapWithTokenSymbolsRoute } from '@/helpers/route.helper';
import ExternalLink from '@/components/ExternalLink.vue';
import TokenIcon from '@/components/token/TokenIcon.vue';
import { NETWORK_ETH_TOKEN_NAME } from '@/helpers/network-eth-token';


export default /*#__PURE__*/_defineComponent({
  __name: 'ControlPanelCollapse',
  props: {
    name: null,
    contractUrl: null,
    toggleInline: { type: Boolean },
    expanded: { type: Boolean },
    brand: null,
    brandIcon: null,
    getBluesButton: { type: Boolean },
    crosschain: { type: Boolean }
  },
  emits: ["update:expanded", "toggle"],
  setup(__props: any, { emit: emits }: { emit: ({
  (e: 'update:expanded', value: boolean): void;
  (e: 'toggle', originalEvent: Event, value: boolean): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  name?: string;
  contractUrl?: string;
  toggleInline?: boolean;
  expanded?: boolean;
  brand?: string;
  brandIcon?: string;
  getBluesButton?: boolean;
  crosschain?: boolean;
}





const { state } = useStore();
const router = useRouter();
const { t } = useI18n();

const isCollapsed = ref(!props.expanded);
const isToggleHover = ref(false);
const toggle = event => {
  isCollapsed.value = !isCollapsed.value;
  emits('update:expanded', !isCollapsed.value);
  emits('toggle', event, isCollapsed.value);
};

const toggleClass = computed(() => {
  let cls = props.toggleInline
    ? 'mt-s4 sm:mt-s0 sm:w-8rem sm:justify-content-end sm:ml-auto'
    : `xl:w-auto mt-s4 xl:mt-s0 sm:justify-content-center`;
  return cls;
});

const buttonClass = computed(() => {
  let cls = props.crosschain && !state.layout.isMobile ? 'xl:mt-s2 xl:-mb-s2 ' : '';
  cls += state.layout.isMobile ? '-mt-s3 ' : '';
  cls += props.toggleInline ? 'sm:justify-content-end ' : 'xl:justify-content-end ';
  return isCollapsed.value ? cls + '' : cls + 'active';
});
const selectedNetCurrency = computed(() => NETWORK_ETH_TOKEN_NAME);

return (_ctx: any,_cache: any) => {
  const _component_Button = _resolveComponent("Button")!
  const _component_Divider = _resolveComponent("Divider")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (__props.crosschain)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('crosschain')), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    (__props.brand)
      ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", null, _toDisplayString(_unref(t)('poweredBy')) + " " + _toDisplayString(__props.brand || 'multichain'), 1)
          ])
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_6, [
      _createElementVNode("div", {
        class: _normalizeClass(["control-panel-title w-full xl:w-16rem sm:flex xl:block", { 'mt-s5': __props.brand }])
      }, [
        _createElementVNode("div", _hoisted_7, [
          (__props.name)
            ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                (__props.brandIcon)
                  ? (_openBlock(), _createBlock(TokenIcon, {
                      key: 0,
                      "icon-src": __props.brandIcon,
                      size: "24",
                      class: "mr-s1",
                      brand: ""
                    }, null, 8, ["icon-src"]))
                  : _createCommentVNode("", true),
                _createElementVNode("div", null, [
                  _createElementVNode("span", {
                    class: _normalizeClass(["mr-s2", __props.crosschain && _unref(state).layout.isMobile ? 'block mr-s15 pr-s15' : ''])
                  }, _toDisplayString(__props.name), 3)
                ])
              ]))
            : _createCommentVNode("", true),
          _renderSlot(_ctx.$slots, "header-title")
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["flex align-items-center gutter-x-s4 text-sm mt-s2", __props.crosschain ? 'sm:mt-s2' : 'xl:mt-s2'])
        }, [
          (__props.contractUrl)
            ? (_openBlock(), _createBlock(ExternalLink, {
                key: 0,
                label: "Contract",
                url: __props.contractUrl,
                color: "secondary"
              }, null, 8, ["url"]))
            : _createCommentVNode("", true),
          _createElementVNode("div", null, [
            (__props.getBluesButton)
              ? (_openBlock(), _createBlock(_component_Button, {
                  key: 0,
                  class: "button-text text-secondary",
                  label: _unref(t)('getBlues'),
                  onClick: _cache[0] || (_cache[0] = ($event: any) => {
                _unref(router).push(_unref(buildSwapWithTokenSymbolsRoute)(_unref(selectedNetCurrency), 'BLUES'));
                _ctx.$emit('click');
              })
                }, null, 8, ["label"]))
              : _createCommentVNode("", true)
          ])
        ], 2)
      ], 2),
      (!_unref(state).layout.isDesktop)
        ? (_openBlock(), _createBlock(_component_Divider, {
            key: 0,
            class: "panel-collapse-divider border-secondary"
          }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_9, [
        _renderSlot(_ctx.$slots, "header-data"),
        _createElementVNode("div", {
          class: _normalizeClass(["flex flex-column sm:flex-row sm:align-items-center w-full", _unref(toggleClass)])
        }, [
          _renderSlot(_ctx.$slots, "toggle-button", {}, () => [
            _createVNode(_component_Button, {
              class: _normalizeClass(["button-toggle sm:ml-s1", _unref(buttonClass)]),
              onClick: toggle,
              "aria-expanded": !isCollapsed.value,
              onMouseenter: _cache[1] || (_cache[1] = ($event: any) => (isToggleHover.value = true)),
              onMouseleave: _cache[2] || (_cache[2] = ($event: any) => (isToggleHover.value = false))
            }, {
              default: _withCtx(() => [
                _createElementVNode("i", {
                  class: _normalizeClass(["pi ml-s2 pi-chevron-down", isCollapsed.value ? '' : 'rotate-180'])
                }, null, 2)
              ]),
              _: 1
            }, 8, ["class", "aria-expanded"])
          ])
        ], 2)
      ])
    ]),
    _createVNode(_Transition, { name: "toggleable-content" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", _hoisted_10, [
          _createVNode(_component_Divider, { class: "panel-collapse-divider" }),
          _createElementVNode("div", _hoisted_11, [
            _renderSlot(_ctx.$slots, "default")
          ])
        ], 512), [
          [_vShow, !isCollapsed.value]
        ])
      ]),
      _: 3
    })
  ]))
}
}

})